import DeletePhotoModal from './delete-photo/index';
import DeleteAccountModal from './delete-account/index';

export { DeletePhotoModal, DeleteAccountModal };



// WEBPACK FOOTER //
// ./src/components/general/modal/types/delete/index.jsx